import React from "react"
import { HtmlToReact } from "@components/html"

const Overview = ({
  title,
  description,
  toggle_wrapper = false,
  expert = null,
  icon = null,
}) => (
  <div className="content-feed-overview text-center">
    {icon ? (
      <div className="img-thumbnail img-circle img-pull-up icon">
        <i
          className={
            icon.startsWith("glyphicon") ? icon : `mbicon mbicon-${icon}`
          }
        />
      </div>
    ) : (
      expert && (
        <figure className="text-center">
          <img
            className="img-thumbnail img-circle img-pull-up"
            src={`/img/experts/${expert.picture}`}
          />
        </figure>
      )
    )}
    {/* className={toggle_wrapper ? "h2" : ""} */}
    {title && <h3>{title}</h3>}
    {description && <HtmlToReact html={description} preset="basic" />}
  </div>
)

export default Overview
